// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__Mhm2d","bold":"Tag_bold__5tN5f","light":"Tag_light__lW6u9"};